import { useState } from "react";
import {
  LessonCardContainer,
  LessonTitleContainer,
  LessonHeaderWrapper,
  LessonNumber,
  LessonTitle,
  ImageCover,
} from "./style";
import Concluded from "../Concluded";
import { useIntl } from "react-intl";
import useEventCode from "../../hooks/useEventCode";

export const LessonCard = ({
  lesson,
  index,
  courseId,
  lessonId,
  noHover = false,
}) => {
  const [flag, setFlag] = useState(!lesson?.url);
  const intl = useIntl();
  const lessonString = intl.formatMessage({
    id: "lesson",
  });
  const eventCode = useEventCode();

  return (
    <LessonCardContainer
      to={`/informa-academy/${eventCode}/course/${courseId}/lesson/${lessonId}`}
      noHoverHomePage={noHover}
    >
      {lesson?.url && lesson.completed && <Concluded overlap />}

      {flag && (
        <>
          <LessonTitleContainer>
            <LessonHeaderWrapper>
              <LessonNumber>{`${lessonString} ${index + 1}`}</LessonNumber>
              {lesson.completed && <Concluded />}
            </LessonHeaderWrapper>
            <LessonTitle>{lesson.title}</LessonTitle>
          </LessonTitleContainer>
        </>
      )}

      {!flag && (
        <ImageCover
          src={lesson?.url}
          loading="lazy"
          alt={`Lesson Cover Image - ${lesson.title}`}
          onError={() => setFlag(true)}
        />
      )}
    </LessonCardContainer>
  );
};

export const LessonCardPreview = ({ title, order, imageUrl }) => {
  const [flag, setFlag] = useState(!imageUrl);
  const intl = useIntl();
  const lessonString = intl.formatMessage({
    id: "lesson",
  });

  return (
    <LessonCardContainer noHover>
      {flag && (
        <>
          <LessonTitleContainer>
            <LessonHeaderWrapper>
              <LessonNumber>{`${lessonString} ${order}`}</LessonNumber>
            </LessonHeaderWrapper>
            <LessonTitle>{title}</LessonTitle>
          </LessonTitleContainer>
        </>
      )}

      {!flag && (
        <ImageCover
          src={imageUrl}
          alt={`Lesson Cover Image - ${title}`}
          onError={() => setFlag(true)}
        />
      )}
    </LessonCardContainer>
  );
};
